import * as React from 'react'

function SvgAddRounded(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.001 16.75v-6c0-3.35-2.36-6.15-5.5-6.83V2.75c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17c-3.14.68-5.5 3.48-5.5 6.83v6l-1.29 1.29c-.63.63-.19 1.71.7 1.71h15.17c.89 0 1.34-1.08.71-1.71l-1.29-1.29zm-7 6c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm1-9.99h2c.55 0 1-.45 1-1v-.01c0-.55-.45-1-1-1h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1v.01c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgAddRounded
